import { jsx as r } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ r(
    "path",
    {
      d: "M21.707 6.793C21.3164 6.4024 20.6836 6.4024 20.2929 6.793L11.9999 15.086L3.707 6.793C3.3164 6.4024 2.6836 6.4024 2.2929 6.793C1.9022 7.1836 1.9023 7.8164 2.2929 8.2071L11.2929 17.2071C11.4882 17.4024 11.7441 17.5001 11.9999 17.5001C12.2557 17.5001 12.5116 17.4024 12.7069 17.2071L21.7069 8.2071C22.0975 7.8165 22.0976 7.1837 21.707 6.793Z",
      fill: "currentColor"
    }
  ) });
}
export {
  t as default
};
